import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UserRole } from 'src/app/enums/user-role.enum';
import { AuthService, ConfigService } from 'src/app/services';
import { SideBarMenu } from '../../models/side-bar-menu.model';
import { SideBarService } from '../../service/side-bar.service';

@Component({
	selector: 'app-item-side-bar',
	templateUrl: './item-side-bar.component.html',
	styleUrls: ['./item-side-bar.component.scss'],
})
export class ItemSideBarComponent implements OnInit {
	@Input('menuitem') menuitem!: SideBarMenu;
	@Output() itemClicked: EventEmitter<SideBarMenu> =
		new EventEmitter<SideBarMenu>();
	activeItem?: string;
	style: any;
	styleLink: any;
	renderItem: boolean = true;
	baseItem: boolean = true;
	baseUrl: string = '';
	open: boolean = false;

	constructor(
		private readonly authService: AuthService,
		private readonly configService: ConfigService,
		private readonly sideBarService: SideBarService,
		private readonly router: Router
	) {}

	ngOnInit(): void {
		this.baseUrl = this.configService.webBaseUrl;

		if (!this.menuitem.enable) {
			return;
		}

		if (this.menuitem.adminRequired) {
			this.renderItem = this.authService.isUserRole(UserRole.RacoAdmin);
		}

		if (this.menuitem.csaRequired) {
			this.renderItem =
				this.authService.isUserRole(UserRole.RacoAdmin) ||
				this.authService.isUserRole(UserRole.CSA);
		}

		this.style = {
			'background-color': `rgb(155,155,155,${
				this.menuitem.opacity / 10
			})`,
		};

		this.styleLink = {
			'background-color': `rgb(155,155,155,${
				this.menuitem.opacity + 1 / 10
			})`,
		};

		this.sideBarService.activeMenuItemUpdated.subscribe((activeItem) => {
			this.activeItem = activeItem;
		});

		let route = this.router.url;
		let finalRoute = route.split('/');

		if (finalRoute.length > 0) {
			this.open = this.shouldOpenMenu(
				this.menuitem,
				finalRoute[finalRoute.length - 1]
			);

			if (this.open) {
				this.sideBarService.setActiveMenuItem(this.menuitem.name);
			}
		}
	}

	onClickItem() {
		this.itemClicked.emit(this.menuitem);
		this.sideBarService.setActiveMenuItem(this.menuitem.name);
	}

	onClickSideItem(item: SideBarMenu) {
		this.itemClicked.emit(item);
	}

	shouldOpenMenu(sideBarMenu: SideBarMenu, route: string): boolean {
		if (sideBarMenu.subMenu) {
			let shouldOpen = false;

			sideBarMenu.subMenu.every((sub) => {
				if (this.shouldOpenMenu(sub, route)) {
					shouldOpen = true;
					return false;
				}
				return true;
			});

			return shouldOpen;
		} else {
			let routerLink = sideBarMenu?.routerLink?.split('/');

			if (routerLink && routerLink.length > 0) {
				let finalRoute = routerLink[routerLink.length - 1];
				return finalRoute == route;
			}

			return false;
		}
	}
}
